export * from './useStorage';
//# sourceMappingURL=index.js.map